module.exports = __webpack_public_path__ + "img/logo.49952959.png";